import NotificationPage from '.';

export const Notification = ({ setNotificationEventTarget }) => (
  <NotificationPage setNotificationEventTarget={setNotificationEventTarget} />
);
